import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { CrudModelPaginatorLaboratory, initialCrudModelBaseState } from '@/shared/models/cruds.models'
import {
    ConfigurationSectionResponse
} from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.dto'
import {
    configurationSectionService
} from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.service'
import { AgGridColumnFilter, AgGridColumnType } from '@/shared/models/ag-grid.model'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { store } from '@/store/store'

export const columnsDefLocalAssaySectionGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            filter: AgGridColumnFilter.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            filter: AgGridColumnFilter.TEXT,
            headerName: i18n.tc('configuration.sections.section'),
            field: 'name',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.NUMBER,
            filter: AgGridColumnFilter.NUMBER,
            headerName: i18n.tc('configuration.sections.priorities'),
            field: 'priority',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.touchMode'),
            field: 'allowsTouchMode',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.trueTracking'),
            field: 'allowsRealTracking',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface ConfigurationLocalAssaysSectionsGridState extends CrudModelPaginatorLaboratory<ConfigurationSectionResponse> {
    service: typeof configurationSectionService
    laboratoryId: number
}
export const initialConfigurationLocalAssaysSectionsGridState =
    (): ConfigurationLocalAssaysSectionsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.assays.assaysSections',
        columnsDef: columnsDefLocalAssaySectionGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationSectionService, store.getters.labId),
        service: configurationSectionService,
        laboratoryId: store.getters.labId
    })
